import { genericJourneyResolverMapping } from '@dxb-web-ui-framework/mocks/msw/types';
import { genericMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/genericMapToHandlers';
import { ecommbx } from '../../index';

const transfersMap: genericJourneyResolverMapping[] = [
  { url: /\/api\/private\/transfers\/parameters\/currencies/, response: () => ecommbx.currenciesData, method: 'get' },
  {
    url: /\/api\/private\/transfers\/exchange\/calculate/,
    response: () => ecommbx.exchangeCalculateData,
    method: 'post',
  },
  { url: /\/api\/public\/accounts\/parameters\/countries/, response: () => ecommbx.countriesData, method: 'get' },
  {
    url: /\/api\/public\/accounts\/parameters\/chargingMethods/,
    response: () => ecommbx.chargingMethodsData,
    method: 'get',
  },
  { url: /\/api\/private\/transfers\/initiate/, response: () => ecommbx.initiateTransferData, method: 'post' },
  { url: /\/api\/private\/transfers\/routing/, response: () => ecommbx.fundTransferRoutingData, method: 'post' },
  { url: /\/api\/private\/transfers\/forecast/, response: () => ecommbx.fundTransferForecastData, method: 'post' },
  { url: /\/api\/private\/transfers\/vop/, response: () => ecommbx.fundTransferVopData, method: 'post' },
  {
    url: /\/api\/private\/transfers\/transfer\/[a-z0-9]+/,
    response: () => ecommbx.makeTransferData,
    method: 'put',
  },
  { url: /\/api\/private\/transfers\/mandates/, response: () => ecommbx.mandateTransferData, method: 'get' },
  { url: /\/api\/private\/transfers\/mandates\/initiate/, response: () => ecommbx.mandateInitiateData, method: 'post' },
  { url: /\/api\/private\/transfers\/mandates/, response: () => ecommbx.mandateExecutionData, method: 'put' },
  { url: /\/api\/private\/transfers\/mandates\/check/, response: () => ecommbx.mandateCheckData, method: 'post' },
  { url: /\/api\/private\/bulk\/mandates\/\d+\/initiate/, response: () => ecommbx.mandateInitiateData, method: 'post' },
  { url: /\/api\/private\/bulk\/mandates/, response: () => ({}), method: 'put' },

  {
    url: /\/api\/private\/transfers\/documents/,
    response: () => ecommbx.fundTransfersPostDocumentData,
    method: 'post',
    responseHeaders: { code: '201' },
  },
  {
    url: /\/api\/private\/transfers\/documents/,
    response: () => ecommbx.fundTransfersPutDocumentData,
    method: 'put',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/transfers\/favorites\/\d+/,
    response: () => ecommbx.favoriteTransferListData,
    method: 'get',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/transfers\/favorites\/\d+\/\d+/,
    response: () => ecommbx.favoriteTransferData,
    method: 'get',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/transfers\/favorites/,
    response: () => ecommbx.favoriteTransferPostData,
    method: 'post',
    responseHeaders: { code: '201' },
  },
  {
    url: /\/api\/private\/transfers\/favorites\/app-transaction/,
    response: () => ecommbx.favoriteAppTransactionPostData,
    method: 'post',
    responseHeaders: { code: '201' },
  },
  {
    url: /\/api\/private\/transfers\/favorites\/\d+\/\d+/,
    response: () => ecommbx.favoriteTransferDeleteData,
    method: 'delete',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/transfers\/favorites\/\d+\/\d+/,
    response: () => ecommbx.favoriteTransferEditData,
    method: 'put',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/transfers\/documents/,
    response: () => ecommbx.fundTransfersPostDocumentData,
    method: 'post',
    responseHeaders: { code: '201' },
  },
  {
    url: /\/api\/private\/transfers\/documents/,
    response: () => ecommbx.fundTransfersPutDocumentData,
    method: 'put',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/transfers\/documents/,
    response: () => ecommbx.fundTransfersDeleteDocumentData,
    method: 'delete',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/transfers\/swift\/codes/,
    response: () => ecommbx.fundTransfersBankSwiftCodesData,
    method: 'get',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/transfers\/swift\/cities/,
    response: () => ecommbx.fundTransfersSwiftCitiesData,
    method: 'get',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/transfers\/swift\/banks/,
    response: () => ecommbx.fundTransfersSwiftBanksData,
    method: 'get',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/transfers\/parameters\/charging-methods/,
    response: () => ecommbx.chargingMethodsData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transfers\/parameters\/bop-codes/,
    response: () => ecommbx.fundTransfersBopCodesData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transfers\/parameters\/voc-codes/,
    response: () => ecommbx.fundTransfersVocCodesData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transfers\/dealer-rate\/execute/,
    response: () => ecommbx.fundTransfersExecuteDealerRateData,
    method: 'put',
  },
  {
    url: /\/api\/private\/transfers\/exchange\/dealer-rates/,
    response: () => ecommbx.fundTransfersDealerRatesData,
    method: 'get',
  },
  {
    url: /\/api\/private\/transfers\/dealer-rate\/initiate/,
    response: () => ecommbx.initiateTransferData,
    method: 'post',
  },
  {
    url: /\/api\/private\/transfers\/swift\/bic\/validate/,
    response: () => ecommbx.bicSwiftCodeData,
    method: 'post',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/transfers\/dealer-rate\/new/,
    response: () => null,
    method: 'post',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/transfers\/dealer-rate\/cancel/,
    response: () => null,
    method: 'post',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/transfers\/current-rate\/initiate/,
    response: () => ecommbx.initiateTransferData,
    method: 'post',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/transfers\/current-rate\/execute/,
    response: () => ecommbx.fundTransfersExecuteDealerRateData,
    method: 'put',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/transfers\/date/,
    response: () => ecommbx.fundTransfersDateTransfer,
    method: 'get',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/transfers\/swift\/countries/,
    response: () => ecommbx.fundTransfersSwiftCountriesData,
    method: 'get',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/accounts\/currencies\/search/,
    response: () => ecommbx.searchCurrencyData,
    method: 'get',
    responseHeaders: { code: '200' },
  },
  {
    url: /\/api\/private\/transfers\/[a-z0-9]+\/charges/,
    response: () => ecommbx.orderChargesData,
    method: 'get',
  },
];

const transfersHandlers = transfersMap.map(genericMapToHandlers);

export { transfersHandlers };
